import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Path} from '../common/path';
import {RestResult} from '../models/response/rest-result';
import {CommonService} from './common.service';
import {SearchRequest} from '../models/request/search-request';
import {BuyerDepositRequest} from '../models/request/buyer/buyer-deposit-request';
import {BuyerDeposit} from '../models/response/buyer/buyer-deposit';

@Injectable()
export class BuyerDepositService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) {
  }

  getOne(buyerDepositId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.BUYER_DEPOSIT +
      Path.BUYER_DEPOSIT_ID.replace(':buyerDepositId', buyerDepositId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.BUYER_DEPOSIT +
      Path.SEARCH, request,
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  create(request: BuyerDepositRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.BUYER_DEPOSIT, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  createOrUpdate(requests: BuyerDeposit[]): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.BUYER_DEPOSIT +
      Path.MULTIPLE, requests).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  remove(buyerDepositId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.BUYER_DEPOSIT +
      Path.BUYER_DEPOSIT_ID.replace(':buyerDepositId', buyerDepositId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  update(request: BuyerDepositRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.BUYER_DEPOSIT, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

}
